import routineReducerFactory from "./routineReducerFactory";
import { fetchFairDynamicWeeksData, addFairDynamicWeek as addFairDynamicWeekRoutine } from "../actions/routines";

export const fairDynamicWeeks = routineReducerFactory(fetchFairDynamicWeeksData);
export const addFairDynamicWeek = routineReducerFactory(addFairDynamicWeekRoutine);
